module.exports = __webpack_public_path__ + "media/images/img-realestate-4-6a8413ba.png";